module.exports = __webpack_public_path__ + "static/img/fish46.25b5446.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/flydragonfish/fish46.png
// module id = cZqs
// module chunks = 0